export default __webpack_public_path__ + "pet.png";